import { Card, Flex, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import IcAgent from '../../icons/IcAgent';
import GridCell from '../../elements/GridCell';
import Button from '../../elements/Button';
import IconArrowRight from '../../icons/IconArrowRight';
import ListFeature from './ListFeature';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';

const MerchantResult = ({
  data={},
  onClick = () => {}
}) => {
  return (
    <Card w="34.228rem" withBorder>
      <Stack>
        <Flex align="center" gap="sm">
          <IcAgent/>
          <Text fz={18}>{data?.storeName || '-'}</Text>
        </Flex>
        <GridCell data={data?.registrationId} label="ID Registrasi" />
        <GridCell data={data?.phoneNumber} label="No. Handphone" />
        <GridCell data={data?.email} label="Email" />
        <Card withBorder>
          <Title fz={18} order={6}>Status Aktivasi Fitur MAP</Title>
          <Stack my="sm">
            {data?.policy?.map((item, idx) => (
              <ListFeature feature={item.id}
                isActive={item.isActivated} key={idx+item.id}
                name={item.menu} {...item} />
            ))}
          </Stack>
          <Button className={styles.cusBtn} onClick={onClick} style="primary-500">
            <Flex align="center" gap="sm">
                Ubah Status Aktivasi Fitur <IconArrowRight/>
            </Flex>
          </Button>
        </Card>
      </Stack>
    </Card>
  );
};

export default MerchantResult;

MerchantResult.defaultProps = {
  data: {},
  onClick: () => {}
};

MerchantResult.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func
};
